<template>
  <div class="div-pc-configuracion-comun-procesos-ta">
    <!-- BLOQUE ALERTAS Y NOTIFICACIONES -->
    <div class="block-title">
      {{ t('common.alertsAndNotifications') }}
    </div>
    <div class="list simple-list margin">
      <ul>
        <li>
          <span class="span-texto-grisAzul-14-400">
            {{ t('production.traceabilityConfiguration.notifications.enable') }}
          </span>
          <label class="toggle toggle-init color-blue">
            <input
              v-model="activarAlertasYNotificaciones"
              type="checkbox"
            >
            <span class="toggle-icon" />
          </label>
        </li>

        <!-- Opciones de Alertas y notificaciones -->
        <div :class="{ deshabilitado: !activarAlertasYNotificaciones }">
          <li>
            <span class="span-texto-grisAzul-14-400">
              {{ t('production.traceabilityConfiguration.notifications.showOnlyForVisibleOrders') }}
            </span>
            <label class="toggle toggle-init color-blue">
              <input
                v-model="filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado"
                type="checkbox"
              >
              <span class="toggle-icon" />
            </label>
          </li>
          <li>
            <span class="span-texto-grisAzul-14-400">
              {{ t('production.traceabilityConfiguration.notifications.showForOrdersModifications') }}
            </span>
            <label class="toggle toggle-init color-blue">
              <input
                v-model="mostrarAlertasYNotificacionesDePedidosModificados"
                type="checkbox"
              >
              <span class="toggle-icon" />
            </label>
          </li>
          <li>
            <span class="span-texto-grisAzul-14-400">
              {{ t('production.traceabilityConfiguration.notifications.showForPlannedAndUnplannedOrders') }}
            </span>
            <label class="toggle toggle-init color-blue">
              <input
                v-model="mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones"
                type="checkbox"
              >
              <span class="toggle-icon" />
            </label>
          </li>
        </div>
      </ul>
    </div>

    <!-- Configuracion de Lectura de cajas en paletizado -->
    <UCCodeScannerConfig
      ref="codeScannerConfigReadBoxRef"
      :title="t('production.traceabilityConfiguration.readBox.title')"
      :config="configuracionLecturaCajasFrmPaletizado"
    />

    <UCCodeScannerConfig
      ref="codeScannerConfigActivityRegRef"
      :title="t('production.traceabilityConfiguration.readActivity.title')"
      :hide-option-orientation="true"
      :hide-option-using-flash="true"
      :hide-option-continuous-read-manual="true"
      :config="configuracionLecturaRegistroActividadFrmPaletizado"
    />

    <!-- Configuracion de Lectura de palés -->
    <UCCodeScannerConfig
      ref="codeScannerConfigReadPaleRef"
      :title="t('production.traceabilityConfiguration.readPallet.title')"
      :hide-option-continuous-read="true"
      :config="configuracionLecturaPaleFrmPaletizado"
    />

    <f7-block-title>
      {{ t('production.traceabilityConfiguration.endOfPallet.title') }}
    </f7-block-title>
    <f7-block>
      <f7-list>
        <f7-list-item>
          <span class="span-texto-grisAzul-14-400">
            {{ t('production.traceabilityConfiguration.endOfPallet.printLabelEndOfPallet') }}
          </span>
          <f7-toggle
            :checked="pesajeFinPale ? false : imprimirEtiquetaFinPale"
            @change="imprimirEtiquetaFinPale = !imprimirEtiquetaFinPale"
          />
        </f7-list-item>
        <f7-list-item>
          <span class="span-texto-grisAzul-14-400">
            {{ t('production.traceabilityConfiguration.endOfPallet.weightEndOfPallet') }}
          </span>
          <f7-toggle
            :checked="imprimirEtiquetaFinPale ? false : pesajeFinPale"
            @change="pesajeFinPale = !pesajeFinPale"
          />
        </f7-list-item>
      </f7-list>
    </f7-block>

    <div class="div-opcionesActions">
      <f7-row style="line-height: 10px;">
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="handleCancel()"
          >
            {{ t('common.cancel').toUpperCase() }}
          </a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="handleConfirmation()"
          >
            {{ t('common.confirm').toUpperCase() }}
          </a>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { useSettingRef } from '@erpagroapp/settings';
import UCCodeScannerConfig from '@/components/common/UCCodeScannerConfig.vue';
import { reactive, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

/** @import { ShallowRef } from 'vue' */

const emit = defineEmits([
  'close',
]);

const { t } = useI18n();
const imprimirEtiquetaFinPale = useSettingRef('Paletizado.FinPale.ImprimirEtiqueta');
const pesajeFinPale = useSettingRef('Paletizado.FinPale.Pesaje');
const activarAlertasYNotificaciones = useSettingRef('Alertas.ActivarConFiltro');
const filtrarAlertasYNotificacionesPorLineaYPuntoDePaletizadoSeleccionado = useSettingRef(
  'Trazabilidad.Alertas.FiltrarPorLineaYPuntoPaletizadoSeleccionado',
);

const mostrarAlertasYNotificacionesDePedidosModificados = useSettingRef(
  'Trazabilidad.Alertas.MostrarAlertasPedidosModificados',
);

const mostrarAlertasYNotificacionesDePlanificacionesYDesplanificaciones = useSettingRef(
  'Trazabilidad.Alertas.PlanificacionesYDesplanificaciones',
);

/** @type {ShallowRef<InstanceType<typeof UCCodeScannerConfig> | null>} */
const codeScannerConfigReadPaleRef = shallowRef(null);
const configuracionLecturaPaleFrmPaletizado = reactive({
  UtilizarFlash: useSettingRef('Paletizado.LecturaPale.UtilizarFlash'),
  OrientacionCamaraLecturaCodigos: useSettingRef('Paletizado.LecturaPale.OrientacionCamaraLecturaCodigos'),
});

/** @type {ShallowRef<InstanceType<typeof UCCodeScannerConfig> | null>} */
const codeScannerConfigReadBoxRef = shallowRef(null);
const configuracionLecturaCajasFrmPaletizado = reactive({
  LecturaContinuaCodigosBarras: useSettingRef('Paletizado.LecturaCajas.LecturaContinuaCodigosBarras'),
  LecturaContinuaCodigosBarrasManual: useSettingRef('Paletizado.LecturaCajas.LecturaContinuaCodigosBarrasManual'),
  UtilizarFlash: useSettingRef('Paletizado.LecturaCajas.UtilizarFlash'),
  OrientacionCamaraLecturaCodigos: useSettingRef('Paletizado.LecturaCajas.OrientacionCamaraLecturaCodigos'),
});

/** @type {ShallowRef<InstanceType<typeof UCCodeScannerConfig> | null>} */
const codeScannerConfigActivityRegRef = shallowRef(null);
const configuracionLecturaRegistroActividadFrmPaletizado = reactive({
  LecturaContinuaCodigosBarras: useSettingRef('Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarras'),
  LecturaContinuaCodigosBarrasManual: useSettingRef('Paletizado.LecturaRegistroActividad.LecturaContinuaCodigosBarrasManual'),
  UtilizarFlash: useSettingRef('Paletizado.LecturaRegistroActividad.UtilizarFlash'),
  OrientacionCamaraLecturaCodigos: useSettingRef('Paletizado.LecturaRegistroActividad.OrientacionCamaraLecturaCodigos'),
});

function handleCancel() {
  resetValues();
  emit('close');
}

function handleConfirmation() {
  const lecturaCajasConfig = codeScannerConfigReadBoxRef.value?.getNewConfig();
  if (lecturaCajasConfig) {
    configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarras = lecturaCajasConfig.LecturaContinuaCodigosBarras;
    configuracionLecturaCajasFrmPaletizado.LecturaContinuaCodigosBarrasManual = lecturaCajasConfig.LecturaContinuaCodigosBarrasManual;
    configuracionLecturaCajasFrmPaletizado.UtilizarFlash = lecturaCajasConfig.UtilizarFlash;
    configuracionLecturaCajasFrmPaletizado.OrientacionCamaraLecturaCodigos = lecturaCajasConfig.OrientacionCamaraLecturaCodigos;
  }

  const lecturaPaleConfig = codeScannerConfigReadPaleRef.value?.getNewConfig();
  if (lecturaPaleConfig) {
    configuracionLecturaPaleFrmPaletizado.UtilizarFlash = lecturaPaleConfig.UtilizarFlash;
    configuracionLecturaPaleFrmPaletizado.OrientacionCamaraLecturaCodigos = lecturaPaleConfig.OrientacionCamaraLecturaCodigos;
  }

  const lecturaRegistroActividadConfig = codeScannerConfigActivityRegRef.value?.getNewConfig();
  if (lecturaRegistroActividadConfig) {
    configuracionLecturaRegistroActividadFrmPaletizado.LecturaContinuaCodigosBarras = lecturaRegistroActividadConfig.LecturaContinuaCodigosBarras;
    configuracionLecturaRegistroActividadFrmPaletizado.LecturaContinuaCodigosBarrasManual = lecturaRegistroActividadConfig.LecturaContinuaCodigosBarrasManual;
    configuracionLecturaRegistroActividadFrmPaletizado.UtilizarFlash = lecturaRegistroActividadConfig.UtilizarFlash;
    configuracionLecturaRegistroActividadFrmPaletizado.OrientacionCamaraLecturaCodigos = lecturaRegistroActividadConfig.OrientacionCamaraLecturaCodigos;
  }

  emit('close');
}

function resetValues() {
  codeScannerConfigReadBoxRef.value?.initialize();
  codeScannerConfigReadPaleRef.value?.initialize();
  codeScannerConfigActivityRegRef.value?.initialize();
}
</script>

<style scoped>
.div-pc-configuracion-comun-procesos-ta {
  width: 100%;
  max-height: 100%;
  height: 54vh;
  overflow-y: auto;
}

.block-title {
  color: #8e8e93 !important;
  font-size: inherit;
  margin: 25px 0 15px 14px;
}

.div-opcionesActions {
  width: 94%;
  left: 0;
  bottom: 0;
  position: absolute;
  padding-bottom: 13px;
  z-index: 2;
}
</style>
